import { suppliersListingStore } from '@/app/features/suppliers/features/suppliers-listing/suppliers-listing.store.js';
import { suppliersDetailsStore } from './features/suppliers-details/suppliers-details.store';
import { newSupplierStore } from './features/new-supplier/new-supplier.store';
export const suppliersStore = {
  modules: {
    supplierListingsState: suppliersListingStore,
    supplierDetailsState: suppliersDetailsStore,
    newSupplierState: newSupplierStore
  }
};
